import type { LoginAnswer } from "@vintecc/capture-api-types/v1";
import { TermsAndPrivacyModal } from "../components/TermsAndPrivacyModal";
import { useDialog } from "@vintecc/components";
import { useEffect, useRef } from "react";

import { ENV } from "@/env";

interface UseTermsAndPrivacyCheckProps {
  loginAnswer: LoginAnswer | null;
  onComplete: () => Promise<void>;
}

export const useTermsAndPrivacyCheck = ({ loginAnswer, onComplete }: UseTermsAndPrivacyCheckProps) => {
  const termsModal = useDialog(TermsAndPrivacyModal);
  const hasOpenedRef = useRef(false);

  useEffect(() => {
    if (loginAnswer && !hasOpenedRef.current) {
      const needsTermsOfService = loginAnswer.acceptedTermsOfService === false && !!ENV.TERMS_AND_CONDITIONS_URL;
      const needsPrivacyPolicy = loginAnswer.acceptedPrivacyPolicy === false && !!ENV.PRIVACY_POLICY_URL;

      if (needsTermsOfService || needsPrivacyPolicy) {
        hasOpenedRef.current = true;
        termsModal.open(
          {
            needsTermsOfService,
            needsPrivacyPolicy,
            onComplete,
          },
          { closeOnOutsideClick: false },
        );
      }
    } else if (loginAnswer?.acceptedTermsOfService === true && loginAnswer?.acceptedPrivacyPolicy === true) {
      // Reset the flag if user has accepted both
      hasOpenedRef.current = false;
    }
  }, [termsModal, loginAnswer, onComplete]);
};
